// Context menu for saved graph items: rename, delete.

import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { getActiveZoom } from '../../lib/zoomPosition';

interface GraphItemMenuProps {
  anchorRect: DOMRect;
  onRename: () => void;
  onDelete: () => void;
  onClose: () => void;
}

export default function GraphItemMenu({
  anchorRect,
  onRename,
  onDelete,
  onClose,
}: GraphItemMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  const z = getActiveZoom();
  const top = anchorRect.bottom / z + 4;
  const left = Math.min(anchorRect.left / z, window.innerWidth / z - 200);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      ref={menuRef}
      className="malpedia-context-menu"
      style={{ top, left }}
      role="menu"
    >
      <button
        className="malpedia-context-menu-item"
        role="menuitem"
        onClick={() => { onRename(); onClose(); }}
      >
        Rename
      </button>
      <div className="malpedia-context-menu-divider" />
      <button
        className="malpedia-context-menu-item malpedia-context-menu-item--danger"
        role="menuitem"
        onClick={() => { onDelete(); onClose(); }}
      >
        Delete
      </button>
    </div>,
    document.body,
  );
}
